import React from "react";
import Helmet from "react-helmet";
import "regenerator-runtime/runtime";
// import UserInfo from "../components/UserInfo/UserInfo";
import Disqus from "../components/Disqus/Disqus";
import PostTags from "../components/PostTags/PostTags";
import SocialLinks from "../components/SocialLinks/SocialLinks";
import SEO from "../components/SEO/SEO";
import Like from "../components/Like";
import config from "../../data/SiteConfig";

export default class PostTemplate extends React.Component {
  render() {
    const {pathContext: {slug}} = this.props;
    const {data: {markdownRemark}} = this.props;
    const post = markdownRemark.frontmatter;
    if (!post.id) {
      post.id = slug;
    }
    if (!post.category_id) {
      post.category_id = config.postDefaultCategoryID;
    }
    return (
      <div>
        <Helmet>
          <title>
            {`${post.title} | ${config.siteTitle}`}
          </title>
        </Helmet>
        <SEO postPath={slug} postNode={markdownRemark} postSEO />
        <div className="section">
          <div className="container" style={{paddingTop: "100px"}}>
            <h1 className="title is-1">
              {post.title}
            </h1>
            <PostTags tags={post.tags} />
            <Like title={post.title} />
            <div dangerouslySetInnerHTML={{__html: markdownRemark.html}} />
            <div className="post-meta">
              <SocialLinks postPath={slug} postNode={markdownRemark} />
            </div>
            <Disqus postNode={markdownRemark} />
          </div>
        </div>
      </div>
    );
  }
}

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query VideoPostBySlug($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      timeToRead
      excerpt
      frontmatter {
        title
        date
        category
        tags
      }
      fields {
        slug
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/video.jsx